/* istanbul ignore next */
const ACTIONS = {
    BRAND_DETERMINATION_ERROR: 'BRAND_DETERMINATION_ERROR',
    GET_SUPPORTED_SITES: 'GET_SUPPORTED_SITES',
    GET_SUPPORTED_SITES_SUCCESS: 'GET_SUPPORTED_SITES_SUCCESS',
    BRAND_DETERMINATION_FIELD_ERROR: 'BRAND_DETERMINATION_FIELD_ERROR',
    TOGGLE_BANKING_LOC_CONTINUE_BUTTON: 'TOGGLE_BANKING_LOC_CONTINUE_BUTTON',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    HANDLE_BANKING_LOC_FIELD_VALUE_CHANGE: 'HANDLE_BANKING_LOC_FIELD_VALUE_CHANGE',
};

/* istanbul ignore next */
const ACTION_CREATORS = {

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_BANKING_LOC_CONTINUE_BUTTON
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.BRAND_DETERMINATION_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setFieldError(fieldName, msg) {
        return {
            type: ACTIONS.BRAND_DETERMINATION_FIELD_ERROR,
            payload: {
                fieldName,
                msg
            }
        };
    },

    handleFieldValueChange(fieldName, fieldValue) {
        return {
            type: ACTIONS.HANDLE_BANKING_LOC_FIELD_VALUE_CHANGE,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    getSupportedSites() {
        return {
            type: ACTIONS.GET_SUPPORTED_SITES
        };
    },

    getSupportedSitesSuccess(siteName, countryList, primarySiteMap) {
        return {
            type: ACTIONS.GET_SUPPORTED_SITES_SUCCESS,
            payload: {
                siteName,
                countryList,
                primarySiteMap
            }
        };
    },
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
